import { createReducer } from 'redux-act';

import {
  PRODUCT_CATEGORIES_FETCH_DATA_INIT,
  PRODUCT_CATEGORIES_FETCH_DATA_SUCCESS,
  PRODUCT_CATEGORIES_FETCH_DATA_FAIL,
  PRODUCT_CATEGORIES_DELETE_CATEGORY_INIT,
  PRODUCT_CATEGORIES_DELETE_CATEGORY_SUCCESS,
  PRODUCT_CATEGORIES_DELETE_CATEGORY_FAIL,
  PRODUCT_CATEGORIES_CLEAR_DATA,
  PRODUCT_CATEGORIES_CREATE_CATEGORY_INIT,
  PRODUCT_CATEGORIES_CREATE_CATEGORY_SUCCESS,
  PRODUCT_CATEGORIES_CREATE_CATEGORY_FAIL,
  PRODUCT_CATEGORIES_MODIFY_CATEGORY_INIT,
  PRODUCT_CATEGORIES_MODIFY_CATEGORY_SUCCESS,
  PRODUCT_CATEGORIES_MODIFY_CATEGORY_FAIL,
  PRODUCT_CATEGORIES_CLEAN_UP,
  PRODUCT_CATEGORIES_CLEAR_DATA_LOGOUT,
  SET_PRODUCT_CATEGORY,
  PRODUCT_SUB_CATEGORIES_FETCH_DATA_INIT,
  PRODUCT_SUB_CATEGORIES_FETCH_DATA_SUCCESS,
  PRODUCT_SUB_CATEGORIES_FETCH_DATA_FAIL,
  PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_FAIL,
  PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_SUCCESS,
  PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_INIT,
  PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_INIT,
  PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_FAIL,
  PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_SUCCESS,
} from 'state/actions/productCategories';

const initialState = {
  list: [],
  listSubCategory: [],
  category: {
    _id: '',
    name: '',
    description: '',
    siteId: '',
    modifiedAt: new Date().toDateString(),
    modifiedBy: '',
  },
  loading: false,
  error: {
    errors: null,
    message: '',
  },
  success: false,
  deleted: false,
  updated: false,
};

export const productCategoriesReducer = createReducer(
  {
    [PRODUCT_CATEGORIES_FETCH_DATA_INIT]: (state) => {
      const isEmpty = Object.keys(state).length === 0;

      return {
        ...(isEmpty ? initialState : state),
        loading: true,
      };
    },
    [PRODUCT_CATEGORIES_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      category: payload.category || initialState.category,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PRODUCT_CATEGORIES_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    //sub category
    [PRODUCT_SUB_CATEGORIES_FETCH_DATA_INIT]: (state) => {
      const isEmpty = Object.keys(state).length === 0;

      return {
        ...(isEmpty ? initialState : state),
        loading: true,
      };
    },
    [PRODUCT_SUB_CATEGORIES_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      listSubCategory: payload.list || [],
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PRODUCT_SUB_CATEGORIES_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      listSubCategory: state.listSubCategory.concat(payload.category),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
      updated: true,
    }),
    [PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      listSubCategory: !state.listSubCategory
        ? []
        : state.listSubCategory.map((elem) => {
            if (elem._id === payload.category._id) {
              return {
                _id: payload.category._id,
                name: payload.category.name,
                logo: payload.category.logo,
                description: payload.category.description,
                siteId: payload.category.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.category.modifiedBy,
                categoryId: payload.category.categoryId,
              };
            }
            return elem;
          }),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
      updated: true,
    }),
    [PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    // end sub category
    [PRODUCT_CATEGORIES_DELETE_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_CATEGORIES_DELETE_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      deleted: true,
    }),
    [PRODUCT_CATEGORIES_DELETE_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_CATEGORIES_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [PRODUCT_CATEGORIES_CREATE_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_CATEGORIES_CREATE_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.category),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
      updated: true,
    }),
    [PRODUCT_CATEGORIES_CREATE_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_CATEGORIES_MODIFY_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_CATEGORIES_MODIFY_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            console.log(payload, 'payload');
            if (elem._id === payload.category._id) {
              return {
                _id: payload.category._id,
                name: payload.category.name,
                logo: payload.category.logo,
                description: payload.category.description,
                siteId: payload.category.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.category.modifiedBy,
              };
            }
            return elem;
          }),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
      updated: true,
    }),
    [PRODUCT_CATEGORIES_MODIFY_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_CATEGORIES_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: false,
      deleted: false,
      updated: false,
    }),
    [PRODUCT_CATEGORIES_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_PRODUCT_CATEGORY]: (state, payload) => ({
      ...state,
      category: payload.data,
    }),
  },
  initialState
);
